/**
 * Loading placeholder matching `ComparisonCard` box-for-box.
 * @returns the skeleton card
 */
export default function ComparisonCardSkeleton() {
  return (
    <div className="flex flex-col gap-1 rounded-3xl border border-landing-primary bg-white p-2">
      <div className="aspect-2/1 animate-pulse rounded-[18px] bg-landing-secondary" />
      <div className="flex flex-col gap-3 p-4">
        <div className="h-5 w-3/5 animate-pulse rounded-full bg-gray-200" />
        <div className="h-3.5 w-full animate-pulse rounded-full bg-gray-100" />
        <div className="h-3.5 w-4/5 animate-pulse rounded-full bg-gray-100" />
        <div className="h-3.5 w-2/5 animate-pulse rounded-full bg-gray-100" />
      </div>
    </div>
  );
}
